import axios from "axios";
import { tokenConfig } from "@/helpers/auth";

export default {
  state() {
    return {
      contacts: [],

      newContactDialog: false,
    };
  },

  getters: {},

  mutations: {
    setNewContactDialog(state, status = null) {
      state.newContactDialog = status;
    },

    refreshContacts(state, payload) {
      state.contacts = [];
      state.contacts = payload;
    },
  },

  actions: {
    getContacts({ dispatch, commit, rootState }, branchId) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            `/api/v1/contacts/contact/${branchId}/branch_contacts/`,
            tokenConfig(rootState)
          )
          .then((response) => {
            commit("setBranchNotFound", false);
            commit("setBranchVendor", response.data["branch_vendor"]);
            commit("refreshContacts", response.data["branch_contacts"]);
            resolve(response);
          })
          .catch((error) => {
            if (error.response && error.response.status === 404)
              commit("setBranchNotFound", true);
            else dispatch("handleError", error);
            reject(error);
          });
      });
    },

    createContact({ dispatch, commit, rootState }, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/api/v1/contacts/contact/`, payload, tokenConfig(rootState))
          .then((response) => {
            dispatch("getContacts", payload.branch);
            commit("setNewContactDialog", false);
            commit("setSnackbar", {
              state: true,
              color: "success",
              comment: "Contact was created successfully",
            });
            resolve(response);
          })
          .catch((error) => {
            dispatch("handleError", error);
            reject(error);
          });
      });
    },
  },
};
